var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreGraphicPickupUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M1.162 7.57h22.086v11.063H1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M1.162 18.633h22.086v2.329H1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M13.949 10.481h6.974v10.481h-6.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M3.487 10.481h8.137v6.405H3.487z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M4.068 11.063h6.974v5.24H4.068z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.47 16.013c-.174 0-.29.116-.29.29v1.165c0 .175.116.291.29.291.175 0 .29-.116.29-.29v-1.165c0-.175-.115-.291-.29-.291z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.487 5.823)",
    fill: "#558B2F"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.718,
    cy: 1.747,
    rx: 1.744,
    ry: 1.747
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.692,
    cy: 1.747,
    rx: 1.744,
    ry: 1.747
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.744,
    cy: 1.747,
    rx: 1.744,
    ry: 1.747
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7CB342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.504 0H2.906c-.64 0-1.162.524-1.162 1.165V2.91h20.923V1.165C22.667.524 22.144 0 21.504 0zM10.462 2.911h3.487v4.658h-3.487zM19.76 2.911h-2.905l.581 4.659h3.487zM4.65 2.911h2.906L6.974 7.57H3.487z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.823)",
    fill: "#FFA000"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.692,
    cy: 1.747,
    rx: 1.744,
    ry: 1.747
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.41 1.747c0 .99-.755 1.747-1.743 1.747a1.714 1.714 0 01-1.744-1.747c0-.99.756-1.747 1.744-1.747l1.743 1.747z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.718,
    cy: 1.747,
    rx: 1.744,
    ry: 1.747
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.747c0 .99.756 1.747 1.744 1.747s1.743-.757 1.743-1.747C3.487.757 2.732 0 1.744 0L0 1.747z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.323 13.625a5.682 5.682 0 00-5.677 5.688A5.682 5.682 0 0019.323 25 5.682 5.682 0 0025 19.313a5.682 5.682 0 00-5.677-5.688z",
    fill: "#D93F22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.784 16.91l1.685 1.684 1.62-1.62c.151-.152.433-.117.628.078.195.196.23.477.078.63L20.176 19.3l1.656 1.656c.152.152.117.434-.078.63-.195.194-.477.23-.629.077l-1.656-1.656-1.722 1.721c-.152.152-.433.117-.629-.078-.195-.195-.23-.477-.078-.629l1.722-1.721-1.685-1.685c-.152-.152-.117-.433.079-.628.195-.196.476-.23.628-.079z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.855 2.911h-2.906V7.57h3.487zM22.667 2.911H19.76l1.162 4.659h3.487zM7.556 2.911h2.906V7.57H6.974zM1.744 2.911H4.65L3.487 7.57H0z"
  })))));
}

export default SvgStoreGraphicPickupUnavailable;